var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('home-page-navbar',{attrs:{"log-in-text":'Inicia Sesión',"secondary-text":'Registrate',"is-company":false}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('home-page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }